import Vue from 'vue'
import VueMq from 'vue-mq'

export default async function () {
  const moduleOptions = {"defaultBreakpoint":"large","breakpoints":{"small":640,"medium":768,"tablet":1024,"large":1200,"xlarge":1440,"xxlarge":Infinity}}
  Vue.use(VueMq, moduleOptions)
}
